"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_PT_TRANS = {
    'time picker': 'Time Picker',
    'today': 'Hoje',
    'set time': 'Definir tempo',
    'close': 'Fechar',
    'cancel': 'Cancelar',
    'confirm': 'Confirmar',
    'hour': 'Hora',
    'minute': 'Minuto',
    'second': 'Segundo',
};
//# sourceMappingURL=pt.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/locale/pt.js
// module id = ../../../../ng-pick-datetime/locale/pt.js
// module chunks = 15